import { useEffect, useRef } from 'react'

const useScrollReveal = () => {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // If the element has a stagger parent, we handle it with individual delays
            entry.target.classList.add('reveal-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -30px 0px',
      }
    )

    const elements = document.querySelectorAll('.reveal')
    elements.forEach((el) => observer.observe(el))

    // Safety fallback: in case IntersectionObserver doesn't trigger quickly (older browsers,
    // or race conditions), reveal elements after 2s so the page never appears blank.
    const fallbackTimer = setTimeout(() => {
      document.querySelectorAll('.reveal:not(.reveal-visible)').forEach((el) => {
        el.classList.add('reveal-visible')
      })
    }, 2000)

    return () => {
      clearTimeout(fallbackTimer)
      observer.disconnect()
    }
  }, [])
}

export default useScrollReveal
